import { useMemo } from 'react';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';
import NsContent from 'components/common/ns-content/NsContent';

import { usePartner } from 'components/app/routes/usePartner';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { BritishGasBenefits } from 'components/direct-sales/quote/components/BritishGasBenefits';
import { PriceCapBanner } from 'components/direct-sales/quote/components/PriceCapBanner';
import { Tariffs } from 'components/direct-sales/quote/components/Tariffs';
import { DirectDebitPromotionExpander } from 'components/direct-sales/quote/components/DirectDebitPromotionExpander';
import { QuoteBillingConsent } from 'components/direct-sales/quote/components/QuoteBillingConsent';
import { QuoteHeader } from 'components/direct-sales/quote/components/QuoteHeader';
import { TariffFilters } from 'components/direct-sales/quote/components/TariffFilters';
import { PARTNERS } from 'config/app-config';
import { useTariffFilters } from './hooks/useTariffFilters';
import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';
import { MoreInformation } from 'components/direct-sales/quote/components/MoreInformation';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';
import { NsAccordion } from 'components/common/ns-accordion/NsAccordion';

export const testId = 'quoteTestId';
export const testIdVoicesalesWindbackAlert = 'testIdVoicesalesWinbackAlert';
export const quoteCaveatTestId = 'quoteCaveatTestId';

export const Quote = () => {
  const { isDSJourney, activePartner } = usePartner();
  const isMoveInJourney = activePartner[PARTNERS.MOVE_IN];
  const isAgentJourney = useIsLoginEnabledJourney();
  const { hasAnyFilter } = useTariffFilters();

  const hasLeftColumn = hasAnyFilter || !isMoveInJourney;
  const columnRatio = hasLeftColumn ? '1:2' : '1';
  const hasAccordion = !isAgentJourney || isDSJourney;

  return useMemo(
    () => (
      <>
        <PriceCapBanner />
        <NsPanel testId={testId} decoration="grey-light">
          <QuoteHeader />
        </NsPanel>
        <NsPanel decoration="grey-light">
          <NsColumn
            hockeypitch={columnRatio}
            footballpitch={columnRatio}
            rugbypitch={columnRatio}
          >
            {hasLeftColumn && (
              <NsContent role="listitem">
                <QuoteBillingConsent shouldShow={!isMoveInJourney} />
                <TariffFilters />
              </NsContent>
            )}

            <Tariffs id="tariffs" />
          </NsColumn>

          {hasAccordion && (
            <NsAccordion>
              <MoreInformation />
              <DirectDebitPromotionExpander shouldShow={isDSJourney} />
            </NsAccordion>
          )}
        </NsPanel>
        <BritishGasBenefits />
        <NsCaveat testId={quoteCaveatTestId} heading="Legal information" />
      </>
    ),
    [columnRatio, isDSJourney, hasLeftColumn, isMoveInJourney, hasAccordion]
  );
};

export default Quote;
